import { useContext, useEffect, useState } from "react"
import VisibilityContext from "src/provider/state-manager/visibilityProvider"
import UserContext from "src/provider/state-manager/userProvider"
import ApiContext from "src/provider/API/call-service"
import { AppSpan, Button, CustomContainer, FlexRow, Form, FormGroup } from "src/style"
import helpers from "src/utils/helpers"
import { AppCenterPopupPlusD2, Portal, TitleWithBackIconD2 } from "src/component"

export const AccountDeletionDetailsD2: React.FC<any> = ({next, back, close}) => {
    const {API} = useContext(ApiContext)
    const {user, setUserProperty} = useContext(UserContext)
    const {notifier} = useContext(VisibilityContext)
    const [input, setInput] = useState({username: user?.userInfo?.profileInfo?.username, accountNumber: ''})
    const [account, setAccount] = useState<any>(null)

    useEffect(() => {
        const account = helpers.getAccountDetailsByParam(user.accountWithBalanceDetails, 'nuban', user?.userInfo?.profileInfo?.primaryAccount)
        setInput({...input, accountNumber: account.nuban})
        setAccount(account)
    }, [user.accountWithBalanceDetails])

    const handleInput = (e: React.ChangeEvent<HTMLInputElement|HTMLTextAreaElement|HTMLSelectElement>) => {
        setInput({...input, [e.target.name]: e.target.value})
    }
    
    async function handleProceed(e: React.FormEvent<HTMLButtonElement | HTMLFormElement>) {
        e.preventDefault()
        await setUserProperty('acctDeletionData', {...input})
        next()
    }

    return (
        <Portal>
            <AppCenterPopupPlusD2
                title='Account Details' 
                height='35' overflow='hidden'
                contentHeight='35' zIndex='6'
                maxHeight='76'
                close={close} 
                back={back}
            >
                <TitleWithBackIconD2 title='Account Details' backMethod={back}/>
                <CustomContainer>
                    <AppSpan>
                        This action will delete your Internet Banking Profile and 
                        you will no longer have access to all your accounts. Please proceed with caution
                    </AppSpan>
                    <Form onSubmit={handleProceed} topMargin='2'>
                        <FormGroup>
                            <label>Username</label>
                            <input 
                                name='username'
                                placeholder="Enter Username"
                                value={input.username}
                                required
                                disabled
                            />
                        </FormGroup>
                        <FlexRow topMargin="2.5">
                            <Button 
                                width='100' sizeUnit="%" height='4.4' 
                                borderColor='#0D968F' hoverBgColor='#ffffff' 
                                hoverColor='#0D968F' titleSize='1.4'
                            >
                                Proceed
                            </Button>
                        </FlexRow>
                    </Form>
                </CustomContainer>
            </AppCenterPopupPlusD2>
        </Portal>
    )
}
